import type { SVGProps } from "react";
const SvgArrowPlainRight = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M127.835 220.37L121.205 226.8C120.791 227.201 120 226.958 120 226.43L120 213.57C120 213.042 120.791 212.799 121.205 213.2L127.835 219.63C128.055 219.843 128.055 220.157 127.835 220.37Z"
      fill="currentColor"
      transform="translate(-112 -208)"
    />
  </svg>
);
export default SvgArrowPlainRight;
